import React, { useState, useCallback } from 'react';
import CustomButton from '../button/CustomButton';
import { getEditableFields } from './exerciseUtils';
import {
  EditFormOverlay,
  EditFormCard,
  EditFormTitle,
  FormField,
  FormLabel,
  FormInput,
  FormSelect,
  FormButtons,
} from './components';

const EditHistoryModal = ({ entry, blockType, onSave, onClose }) => {
  const fields = getEditableFields(blockType);
  const [values, setValues] = useState(() => {
    const initial = {};
    fields.forEach(({ key }) => {
      initial[key] = entry.record?.[key] ?? '';
    });
    return initial;
  });
  const [saving, setSaving] = useState(false);

  const handleChange = useCallback((key, value) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleSave = useCallback(async () => {
    setSaving(true);
    const updates = {};
    fields.forEach(({ key, type }) => {
      const val = values[key];
      if (val === '' || val === null || val === undefined) return;
      if (type === 'number') {
        updates[key] = parseFloat(val);
      } else {
        updates[key] = val;
      }
    });
    try {
      await onSave(entry.uid, updates);
      onClose();
    } catch (err) {
      console.error('Failed to save:', err);
    }
    setSaving(false);
  }, [entry, values, fields, onSave, onClose]);

  return (
    <EditFormOverlay onClick={onClose}>
      <EditFormCard onClick={(e) => e.stopPropagation()}>
        <EditFormTitle>Edit Record</EditFormTitle>
        {fields.map(({ key, label, type, step, options }) => (
          <FormField key={key}>
            <FormLabel>{label}</FormLabel>
            {type === 'select' ? (
              <FormSelect
                value={values[key] || ''}
                onChange={(e) => handleChange(key, e.target.value)}
              >
                <option value="">-</option>
                {options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </FormSelect>
            ) : (
              <FormInput
                type={type === 'number' ? 'number' : 'text'}
                step={step}
                value={values[key] ?? ''}
                onChange={(e) => handleChange(key, e.target.value)}
              />
            )}
          </FormField>
        ))}
        <FormButtons>
          <div style={{ flex: 1 }}>
            <CustomButton
              outlined
              borderRadius="8px"
              outlineColor="#e9eaed"
              backgroundColor="#ffffff"
              color="#373333"
              height="3.6rem"
              fontSize="1.4rem"
              onClick={onClose}
            >
              Cancel
            </CustomButton>
          </div>
          <div style={{ flex: 1 }}>
            <CustomButton
              borderRadius="8px"
              backgroundColor="#00FF91"
              color="#001212"
              height="3.6rem"
              fontSize="1.4rem"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save'}
            </CustomButton>
          </div>
        </FormButtons>
      </EditFormCard>
    </EditFormOverlay>
  );
};

export default EditHistoryModal;
